/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { dependentsServices } from '../../../api/services/dependentsServices';
import {
  setAlldependentslist,
  setAlldependentslistLoader,
} from '../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';

interface PropsValues {
  setDependentsData: (data: any) => void;
}
function DTODependents({ setDependentsData }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const allEmp_Dependents = useAppSelector(
    (state) => state.dependentslistSlice.dependentslist,
  );
  const dispatch = useAppDispatch();
  const full_path = '';
  async function getEmpDependents(empId: number, full_path: string) {
    dispatch(setAlldependentslistLoader(true));
    const response: any = await dependentsServices.getEmpDependents(
      empId,
      full_path,
    );

    if (response.response == 'success') {
      const dependentslist: any = response?.data;

      dispatch(setAlldependentslist(dependentslist));
      /* Passing Props to Controller */

      setDependentsData(dependentslist);
      dispatch(setAlldependentslistLoader(false));
    } else {
      dispatch(setAlldependentslistLoader(false));

      return;
    }
  }

  useEffect(() => {
    getEmpDependents(selector.emp_id, full_path);
  }, []);

  useEffect(() => {
    setDependentsData(allEmp_Dependents);
  }, [allEmp_Dependents]);

  return <></>;
}

export default DTODependents;
